export default "__VITE_ASSET__$pIMMDEi__"